module.exports = __webpack_public_path__ + "media/images/saint barthelemy-006eda2354fa784b067dd15e2e44f731.svg";